import React, { useState, useEffect, useRef } from "react";
import "../styles/About.css"; // Create this new stylesheet
import hbsLogo from "../assets/hbs-logo.png"; // Importing image
import ilabLogo from "../assets/ilab-logo.png";
import apartmentSplash from "../assets/ApartmentSplash.jpg"; // Import the image

function AboutUs() {
	
	const [scrolled, setScrolled] = useState(false);
    const contentRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            if (contentRef.current) {
                console.log("Scroll position:", contentRef.current.scrollTop);
                setScrolled(contentRef.current.scrollTop > 50);
            }
        };

        const contentElement = contentRef.current;
        if (contentElement) {
            contentElement.addEventListener("scroll", handleScroll);
        }

        return () => {
            if (contentElement) {
                contentElement.removeEventListener("scroll", handleScroll);
            }
        };
    }, []);


    return (
        <div className="about-container">
            <div className="about-content" ref={contentRef}>
				<div className = "align-box">
					<div className="Page-Content">
						<div className="about-text">
							<h1>What is MILO?</h1>
							<p>MILO is a next-generation rental platform that redefines how apartments are listed and found. Here’s how we’re changing the game:</p>
						</div>

						<div className="about-text">
							<h2>For Tenants:</h2>
							<p>
								Begin your rental journey by creating a verified profile on MILO. Our streamlined process puts your application front and center, ensuring you only see apartments for which you qualify. With pre-confirmed eligibility, you can secure your next appartment with just one click. If it's on MILO, it's available—no more wasting time chasing down units that are already rented. Enjoy a hassle-free, efficient rental experience tailored to you.
							</p>

							<h2>For Landlords & Brokers:</h2>
							<p>
								Empower your property management with MILO. Define your ideal tenant profile—whether it's based on credit scores, income thresholds, or other custom criteria—and instantly connect with pre-qualified leads. Our smart filtering system eliminates unqualified inquiries, allowing you to spend less time screening and more time closing deals. 
								Once a lease is signed, our platform automatically updates your portfolio by removing the unit from active listings, ensuring your property data stays current effortlessly.
							</p>
							<h2>Our Vision</h2>
								<p>At MILO, we're not just transforming the rental experience for today—we’re building the future of renting.</p>
								<p>Our journey begins by harnessing proven qualification metrics to flawlessly connect ideal tenants with the perfect properties. As we collect deeper insights and fine-tune our algorithms, we’re moving beyond basic criteria to develop a dynamic, predictive system that benefits every stakeholder.</p>
								<p>Join us as an early adopter—whether you're on the hunt for your next apartment or ready to list your property—and help set a bold new standard for renting in Boston.</p>

						</div>
					</div>
				</div>

				<div className="about-cta">
					<a href="/waitlist" className="cta-button primary">Join the Waitlist</a>
					<a href="/contact/WhatIsMILO" className="cta-button secondary">Contact Us</a>
				</div>
            </div>
            <div className={`about-image ${scrolled ? "scrolled" : ""}`} style={{ backgroundImage: `url(${apartmentSplash})` }}></div>
        </div>
    );
}

export default AboutUs;
